import qs from 'qs';
import client from './rest/AdminClient';

export const getAccessorials = (query = {}) => {
  const path = `/api/v2/accessorials?${qs.stringify({
    sort: true,
    paginate: true,
    sort_by: 'slug',
    order: 'asc',
    ...query,
    _: Date.now(),
  })}`;
  return client({
    method: 'GET',
    path,
  });
};

export const getStandardAccessorials = (query = {}) => {
  const path = `/api/rates/accessorial/standard?${query}`;
  return client({
    method: 'GET',
    path,
  });
};

export const upsertStandardAccessorials = (rows) => {
  return client({
    method: 'PUT',
    path: `/api/rates/accessorial/standard`,
    entity: JSON.stringify({ accessorialRates: rows }),
  });
};

export const createAccessorial = (accessorial) => {
  return client({
    method: 'POST',
    path: '/admin/api/accessorials',
    entity: JSON.stringify(accessorial),
  });
};

export const updateAccessorial = (accessorial) => {
  return client({
    method: 'PATCH',
    path: `/admin/api/accessorials/${accessorial._id}`,
    entity: JSON.stringify(accessorial),
  });
};

export const deleteAccessorial = (accessorial) => {
  return client({
    method: 'DELETE',
    path: `/admin/api/accessorials/${accessorial._id}`,
  });
};
